import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import it from "./it.json";
var locales;
if (navigator.language === "it-IT") {
  locales = "it";
} else {
  locales = "en";
}
i18n.use(initReactI18next).init({
  resources: {
    en,
    it,
  },
  fallbackLng: locales,
  debug: true,
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    formatSeparator: ",",
  },
  react: {
    wait: true,
  },
});
export default i18n;
